package com.hyperether.resources

/**
 * Generated AppLocale enum - represents available locales in the app
 */
enum class AppLocale(
    val code: String, 
    val displayName: String,
    val nativeName: String
) {
    DEFAULT("en", "English", "English"),
    DE("de", "German", "Deutsch");
    
    companion object {
        /**
         * Get all supported locales with their English display names
         * @return Map of language codes to English display names
         */
        val supportedLocales: Map<String, String> by lazy {
            values().associate { locale ->
                locale.code to locale.displayName
            }
        }
        
        /**
         * Get all supported locales with their native display names
         * @return Map of language codes to native display names
         */
        val supportedNativeLocales: Map<String, String> by lazy {
            values().associate { locale ->
                locale.code to locale.nativeName
            }
        }
        
        /**
         * Find locale by language code
         * @param code The language code to search for
         * @return The matching AppLocale or DEFAULT if not found
         */
        fun findByCode(code: String): AppLocale {
            return values().find { it.code == code } ?: DEFAULT
        }
    }
}